  (function () {
    if (window.__loyaltyPointsInit) return;
    window.__loyaltyPointsInit = true;

    function getQuantity(block) {
      var scope = block.closest('product-info, product-content, .product, section') || document;
      var qtyInput = scope.querySelector('[data-quantity-input], input[name="quantity"]');
      return qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    }

    // Pre-launch (early access): premium klanten betalen de gekorte prijs,
    // dus daar rekenen we de goudstaven over. Zelfde afkapping als Shopify.
    function applyPrelaunch(block, price) {
      var pct = parseInt(block.getAttribute('data-prelaunch-pct'), 10) || 0;
      if (pct <= 0) return price;
      return price - Math.floor((price * pct) / 100);
    }

    /**
     * Animate the loyalty-value to a new target. Adds --updating + --bump-X
     * classes voor de visuele bump. Na 140ms vervangt textContent. Na nog
     * 950ms verwijdert de --pulse + --bump classes. No-op bij gelijke value.
     */
    function animatePointsChange(block, valueEl, points) {
      var current = parseInt(valueEl.textContent, 10);
      if (current === points) return;
      var direction = points > current ? 'up' : 'down';
      block.classList.add('loyalty-points--updating');
      block.classList.remove('loyalty-points--bump-up', 'loyalty-points--bump-down');
      // Force reflow to restart CSS animation when same class re-applied
      void block.offsetWidth;
      block.classList.add('loyalty-points--bump-' + direction);
      setTimeout(function () {
        valueEl.textContent = points;
        block.classList.remove('loyalty-points--updating');
        block.classList.add('loyalty-points--pulse');
        setTimeout(function () {
          block.classList.remove('loyalty-points--pulse');
          block.classList.remove('loyalty-points--bump-up', 'loyalty-points--bump-down');
        }, 950);
      }, 140);
    }

    function updateBlock(block, variant, qty) {
      if (!block) return;
      var multiplier = parseFloat(block.getAttribute('data-multiplier')) || 9;
      var hideUnavail = block.getAttribute('data-hide-when-unavailable') === 'true';
      var valueEl = block.querySelector('[data-loyalty-value]');
      if (!valueEl) return;

      if (!variant) {
        // Keep last value; do nothing.
        return;
      }

      if (hideUnavail && variant.available === false) {
        block.setAttribute('hidden', '');
        return;
      }
      block.removeAttribute('hidden');

      var quantity = qty || getQuantity(block);
      var price = typeof variant.price === 'number' ? variant.price : parseFloat(variant.price);
      if (isNaN(price)) return;
      price = applyPrelaunch(block, price);
      var points = Math.round((price / 100) * multiplier * quantity);
      animatePointsChange(block, valueEl, points);
    }

    function resolveVariantFromId(productId, variantId) {
      // Global scope lookup: Shopify theme stores per-product variant JSON in
      // <variant-picker> elements. Scan them.
      var pickers = document.querySelectorAll('variant-picker');
      for (var i = 0; i < pickers.length; i++) {
        var p = pickers[i];
        var script = p.querySelector('script[type="application/json"]');
        if (!script) continue;
        try {
          var variants = JSON.parse(script.textContent || '[]');
          for (var j = 0; j < variants.length; j++) {
            if (variants[j].id === variantId) return variants[j];
          }
        } catch (e) {}
      }
      return null;
    }

    function handleVariantChange(e) {
      // INP hotspot: deze listener zit op document — voor elke change event op de
      // hele pagina (search, newsletter, login form, qty inputs) liep ie tot aan
      // de querySelectorAll/JSON.parse pad. Tightest mogelijke short-circuit:
      // alleen verder als e.target zelf de hidden variant-input is.
      var t = e.target;
      if (!t || t.tagName !== 'INPUT' || t.name !== 'id') return;
      var input = t;

      var variantId = parseInt(input.value, 10);
      if (!variantId) return;

      // Find the product-info scope, then update loyalty blocks within it.
      var scope = input.closest('product-info, product-content, .product, body') || document;
      var blocks = scope.querySelectorAll('[data-loyalty-points]');
      if (!blocks.length) return;

      blocks.forEach(function (block) {
        // Bundel bezit dit blok → de losse variantprijs mag het bundeltotaal
        // niet terugdraaien (zie handleBundleTotal / data-bundle-owned).
        if (block.getAttribute('data-bundle-owned') === '1') return;
        var productId = block.getAttribute('data-product-id');
        var variant = resolveVariantFromId(productId, variantId);
        if (!variant) return;
        // Update data-base-points zodat handleQuantityChange (base × qty)
        // de juiste waarde gebruikt voor de nieuwe geselecteerde variant.
        var multiplier = parseFloat(block.getAttribute('data-multiplier')) || 9;
        var price = typeof variant.price === 'number' ? variant.price : parseFloat(variant.price);
        if (!isNaN(price)) {
          price = applyPrelaunch(block, price);
          var newBase = Math.round((price / 100) * multiplier);
          block.setAttribute('data-base-points', newBase);
        }
        updateBlock(block, variant);
      });
    }

    document.addEventListener('change', handleVariantChange);

    // Quantity change — update loyalty points via base × qty.
    // Geen variant lookup: variant-changes hebben hun eigen handler die
    // data-base-points up-to-date houdt voor de huidige variant. Qty-
    // changes vermenigvuldigen simpelweg met het opgeslagen base.
    function handleQuantityChange(e) {
      // INP hotspot: gebonden aan document.change + document.input — vuurt op elke
      // keystroke document-wide. Skip alles wat geen qty-input is voordat we ook
      // maar closest() lopen.
      var t = e.target;
      if (!t || t.tagName !== 'INPUT') return;
      if (t.name !== 'quantity' && !t.hasAttribute('data-quantity-input')) return;
      var qtyInput = t;
      var scope = qtyInput.closest('product-info, product-content, .product, .quick-view, quick-view, section') || document;
      var blocks = scope.querySelectorAll('[data-loyalty-points]');
      if (!blocks.length) return;
      var qty = parseInt(qtyInput.value, 10) || 1;

      blocks.forEach(function (block) {
        // Bundel bezit dit blok → de PDP-qty telt niet mee; het aantal wordt
        // door de bundel-widget zelf in het totaal verrekend.
        if (block.getAttribute('data-bundle-owned') === '1') return;
        var base = parseInt(block.getAttribute('data-base-points'), 10);
        if (!base || isNaN(base)) return;
        var valueEl = block.querySelector('[data-loyalty-value]');
        if (!valueEl) return;
        animatePointsChange(block, valueEl, base * qty);
      });
    }

    document.addEventListener('change', handleQuantityChange);
    document.addEventListener('input', handleQuantityChange);

    // Bundel-totaal (cn-bundle-app) — op een PDP met een bundel-widget betaalt de
    // klant niet de losse variantprijs maar het bundeltotaal (ná bundelkorting).
    // De widget zendt bij elke herberekening `cn-bundle:total` uit; wij rekenen de
    // goudstaven over dat bedrag. Vanaf dat moment "bezit" de bundel het blok
    // (data-bundle-owned), zodat de variant-/qty-handlers het niet meer overschrijven.
    // Meerdere widgets op één PDP (bv. FBT + staffel): het laatst gevuurde event wint.
    function handleBundleTotal(e) {
      var total = e.detail && e.detail.total;
      // total is in euro's (bv. 67.47) — anders dan variant.price (centen),
      // dus hier NIET door 100 delen.
      if (typeof total !== 'number' || !isFinite(total)) return;

      var blocks = document.querySelectorAll('[data-loyalty-points]');
      if (!blocks.length) return;

      blocks.forEach(function (block) {
        var valueEl = block.querySelector('[data-loyalty-value]');
        if (!valueEl) return;
        var multiplier = parseFloat(block.getAttribute('data-multiplier')) || 9;
        var points = Math.round(total * multiplier);
        block.setAttribute('data-bundle-owned', '1');
        block.removeAttribute('hidden'); // bundel actief → blok altijd tonen
        animatePointsChange(block, valueEl, points);
      });
    }

    document.addEventListener('cn-bundle:total', handleBundleTotal);

    // Also catch quantity button clicks (minus at qty=1 doesn't fire change event)
    document.addEventListener('click', function(e) {
      var qtyBtn = e.target.closest && e.target.closest('quantity-btn, .quantity__btn');
      if (!qtyBtn) return;
      setTimeout(function() {
        // Vind de qty input via DOM proximity (sibling/descendant van de
        // qty wrapper) ipv via scope. Quickview, PDP en mobile carousel
        // hebben elk hun eigen qty input — closest-quantity-wrapper geeft
        // gegarandeerd de juiste, niet de eerste in scope.
        var qtyWrapper = qtyBtn.closest('.quantity, .quantity-input, [class*="quantity"]:not([class*="btn"]):not([class*="input"])');
        var qtyInput = qtyWrapper && qtyWrapper.querySelector('input[type="number"], [data-quantity-input], input[name="quantity"]');
        // Fallback: search in scope
        if (!qtyInput) {
          var scope = qtyBtn.closest('product-info, product-content, .product, .quick-view, quick-view, section') || document;
          qtyInput = scope.querySelector('[data-quantity-input], input[name="quantity"]');
        }
        if (!qtyInput) return;
        handleQuantityChange({ target: qtyInput });
      }, 50);
    });

    // Dialog open / close
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest && e.target.closest('[data-loyalty-open]');
      if (openBtn) {
        var id = openBtn.getAttribute('aria-controls');
        var dlg = id && document.getElementById(id);
        if (dlg && typeof dlg.showModal === 'function') {
          dlg.showModal();
        } else if (dlg) {
          dlg.setAttribute('open', '');
          dlg.style.display = 'block';
        }
        return;
      }

      var closeBtn = e.target.closest && e.target.closest('[data-loyalty-close]');
      if (closeBtn) {
        var dlg2 = closeBtn.closest('dialog');
        if (dlg2 && typeof dlg2.close === 'function') {
          dlg2.close();
        } else if (dlg2) {
          dlg2.removeAttribute('open');
          dlg2.style.display = 'none';
        }
        return;
      }

      // Click on backdrop closes dialog (native dialog only triggers click on
      // the backdrop when clicking outside the panel).
      var dlg3 = e.target.closest && e.target.closest('dialog.loyalty-points__dialog');
      if (dlg3 && e.target === dlg3) {
        if (typeof dlg3.close === 'function') dlg3.close();
        else dlg3.removeAttribute('open');
      }
    });
  })();
